<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                {{$t('Información Básica')}}
            </template>
            <template v-slot:subtitle>
                {{$t('solicitada')}}
            </template>
            <template v-slot:content>
                
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="state">{{$t('Solicitud para un tercero')}}</label>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <Checkbox v-model="datos.tercero" :binary="true" @change="Tercero()"/>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid" >
					<div class="p-field p-col-12 p-md-2" v-if="perfil">
						<label>{{$t('Número ID')}}</label>
						<InputText v-model="datos.code" type="text" :disabled="perfil.code  && !datos.tercero"/>
                        <small v-show="validationErrors.code && submitted" class="p-error">{{$t('required')}}</small>
					</div>
                    <div class="p-field p-col-12 p-md-3">
                        <label>{{$t('Nombre Completo')}} / {{$t('Compañía')}}</label>
                        <InputText v-model="datos.nombre" type="text" :disabled="!datos.tercero"/>
                    <small v-show="validationErrors.nombre && submitted" class="p-error">{{$t('required')}}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label>{{$t('Correo')}}</label>
                        <InputText v-model="datos.correo" type="text"/>
                         <small v-show="validationErrors.correo && submitted" class="p-error">{{$t('required')}}</small>
                    </div>
					<div class="p-field p-col-12 p-md-3">
						<label>{{$t('Nacionalidad')}}</label>
						<Dropdown v-model="datos.nacionalidad" :options="nacionalidades" optionLabel="nacionalidad" :filter="true" placeholder="Selecciona..." v-if="i18n.locale() == 'es'">
							<template #value="slotProps">
								<div class="p-dropdown-car-value" v-if="slotProps.value">
									<span> {{slotProps.value.nacionalidad}}</span>
								</div>
								<span v-else>
									{{slotProps.placeholder}}
								</span>
							</template>
							<template #option="slotProps">
								<div class="p-dropdown-car-option">
									<span> {{slotProps.option.nacionalidad}}</span>
								</div>
							</template>
						</Dropdown>
						<Dropdown v-model="datos.nacionalidad" :options="nacionalidades" optionLabel="nationality" :filter="true" placeholder="Selecciona..." v-if="i18n.locale() == 'en'">
							<template #value="slotProps">
								<div class="p-dropdown-car-value" v-if="slotProps.value">
									<span> {{slotProps.value.nationality}}</span>
								</div>
								<span v-else>
									{{slotProps.placeholder}}
								</span>
							</template>
							<template #option="slotProps">
								<div class="p-dropdown-car-option">
									<span> {{slotProps.option.nationality}}</span>
								</div>
							</template>
						</Dropdown>
                        <small v-show="validationErrors.nacionalidad && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-12 p-md-2">
						<label>{{$t('Teléfono móvil')}}</label>
						<InputMask v-model="datos.celular" mask="+99999 999999"/>
                        <small class="p-error" v-if="i18n.locale() == 'es'">Incluir código del país</small>
                        <small class="p-error" v-if="i18n.locale() == 'en'">Include country code</small>                    
                        <small v-show="validationErrors.celular && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-12 p-md-2">
						<label>{{$t('Teléfono privado')}}</label>
						<InputMask v-model="datos.tlflocal" mask="+99999 999999"/>
                        <small class="p-error" v-if="i18n.locale() == 'es'">Incluir código del país</small>
                        <small class="p-error" v-if="i18n.locale() == 'en'">Include country code</small>                    
					</div>                    
					<div class="p-field p-col-12 p-md-3">
						<label>{{$t('Localidad')}}</label>
                        <InputText v-model="datos.localidad.nombre" type="text" disabled v-if="i18n.locale() == 'es' && datos.localidad"/>
                        <InputText v-model="datos.localidad.name" type="text" disabled v-if="i18n.locale() == 'en' && datos.localidad"/>
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label>{{$t('Fecha de nacimiento')}}</label>
                        <InputMask v-model="datos.fecha" placeholder="DD/MM/YYYY" slotChar="DD/MM/YYYY" mask="99/99/9999"/>
                        <small v-show="validationErrors.fecha && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-12 p-md-2">
						<label>{{$t('Sexo')}}</label>
                        <Dropdown id="state" v-model="datos.sexo" :options="sexos" optionLabel="nombre" placeholder="Seleccione..." v-if="i18n.locale() == 'es'"></Dropdown>
                        <Dropdown id="state" v-model="datos.sexo" :options="sexos" optionLabel="name" placeholder="Select..." v-if="i18n.locale() == 'en'"></Dropdown>
                        <small v-show="validationErrors.sexo && submitted" class="p-error">{{$t('required')}}</small>
					</div>
                   
                </div>
                
            </template>
            <template v-slot:footer>
                <div class="p-grid p-nogutter p-justify-between">
                    <Button :label="$t('Anterior')" @click="prevPage()" icon="pi pi-angle-left" />
                    <Button :label="$t('Siguiente')" @click="nextPage()" icon="pi pi-angle-right" iconPos="right"/>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import API from "@/service/ApiConsulta";
import { useI18nPlugin } from '@unify/vuex-i18n';

export default {
    data () {
        return {
			size: '60vw',
			i18n: null,
			perfil: null,
			nacionalidades: null,
			localidades: null,
			sexos: null,
			datos: {
                tercero: false,
                code: null,
                nombre: null,
                correo: null,
                celular: null,
                tlflocal: null,
                nacionalidad: null,
                localidad: null,
                tipocliente: null,
                sexo: null,
                fecha: null
			},
            submitted: false,
            validationErrors: {},
        }
    },
	created() {
		this.i18n = useI18nPlugin();
        this.$store.commit('Loading');
        const Consulta = new API('Cotizacion');
		Consulta.Ini('Salud').then(result => {
			//this.$store.state.error = result.consult.localidades;	
			this.perfil = result.consult.perfil;
            this.nacionalidades = result.consult.nacionalidades;
            this.datos.localidad = result.consult.localidades;
			this.sexos = result.consult.sexos;
            this.Datos();
            this.$store.commit('Loading');
		}); 
	},
    methods: {
		Datos() {
			this.verifdatos = true;
			this.datos.code = this.perfil.code;
			this.datos.nombre = this.perfil.nombre;
			this.datos.correo = this.perfil.correo;
			this.datos.celular = this.perfil.celular;
			this.datos.tlflocal = this.perfil.tlflocal;
            const Consulta = new API('Cotizacions');
            this.datos.fecha = Consulta.fstring(this.perfil.fechnac);
            this.datos.sexo = this.perfil.sexo;
            this.nacionalidades.forEach(element => {
                if(this.perfil.nacionalidad==element.code){
                    this.datos.nacionalidad = element;
                }
            });  
            this.sexos.forEach(element => {
                if(this.perfil.sexo==element.code){
                    this.datos.sexo = element;
                }
            });  
		},
        Tercero(){
            if (this.datos.tercero){
                this.datos.code = null;
				this.datos.nombre = null;
				this.datos.correo = null;
				this.datos.celular = null;
				this.datos.tlflocal = null;
				this.datos.sexo = null;
				this.datos.fecha = null;
            } else {
                this.Datos();
            }
        },
        prevPage() {
            this.$router.push({ path: '/quotation'});
        },
        nextPage() {
            this.submitted = true;
            if (this.validateForm() ) {
                this.$emit('next-page', {formData: {datos: this.datos}, pageIndex: 0});
            }
        },
        validateForm() {
            if (!this.datos.code)
                this.validationErrors['code'] = true;
            else
                delete this.validationErrors['code'];
            if (!this.datos.nombre)
                this.validationErrors['nombre'] = true;
            else
                delete this.validationErrors['nombre'];
            if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.
                test(this.datos.correo))
                this.validationErrors['correo'] = true;
            else
                delete this.validationErrors['correo'];
            if (!this.datos.celular)
                this.validationErrors['celular'] = true;
            else
                delete this.validationErrors['celular'];
            if (!this.datos.nacionalidad)
                this.validationErrors['nacionalidad'] = true;
            else
                delete this.validationErrors['nacionalidad'];
            if (this.datos.fecha.length!=10)
                this.validationErrors['fecha'] = true;
            else
                delete this.validationErrors['fecha'];
            if (!this.datos.sexo)
                this.validationErrors['sexo'] = true;
            else
                delete this.validationErrors['sexo'];

            return !Object.keys(this.validationErrors).length;
        }
    }
}
</script>